import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient) { }

  uploadMultiFiles(formDate: FormData) {
    // const formData: FormData = new FormData();
    // formData.append('file', file, file.name);
    return this.http.post<any>(
      `${environment.API_URL_UTIL}/api/uploadMultipleFiles`, formDate);
  }

  uploadFile(formDate: FormData) {
    return this.http.post<any>(
      `${environment.API_URL_UTIL}/api/uploadFile`, formDate);
  }

}
